/** Canonical WMS identifiers for terminal-client persistence. */
export const BRAND_CODE = 'WMS'
export const BRAND_NAMESPACE = 'wms'
export const TERMINAL_DRAFT_DATABASE = `${BRAND_NAMESPACE}-terminal-drafts`
export const LOCALE_STORAGE_KEY = `${BRAND_NAMESPACE}-h5-locale`
